import { BadgeProps, useBadgeRepository } from '@frontend/repository';
import React from 'react';
import { IconType } from 'react-icons';
import { RiExternalLinkLine } from 'react-icons/ri';
import { FormattedMessage } from 'react-intl';

export interface ObjectBadgeProps<T> {
    id?: string;
    className?: string;
    callback?: (object: T) => void;
    navigateString?: (object: T) => string;
    navigateOnDisplayName?: boolean;
    /**
     * @deprecated
     */
    icon?: IconType | null;
    disableClick?: boolean;
    mapDisplayName?: (entity: T) => string;
    resolve?: (id: string) => string;
}

export const ObjectBadge = <T,>(props: BadgeProps<T>) => {
    const repository = useBadgeRepository<T>(props);
    return (
        <span
            id={'badge-' + props.id}
            className={
                props.className
                    ? props.className
                    : `text-primary/70 flex items-center text-sm ${repository.disabled ? 'text-primary/50' : props.navigateOnDisplayName ? 'text-primary/70' : ''} m-1`
            }>
            {repository.displayName ? (
                <span
                    onClick={(e) =>
                        !props.disableClick &&
                        !repository.disabled &&
                        repository.isPlatform &&
                        props.navigateString &&
                        repository.object &&
                        props.navigateOnDisplayName &&
                        repository.adminOnClick(e, props.navigateString(repository.object))
                    }>
                    {repository.displayName}
                </span>
            ) : (
                <span className='placeholder-glow'>
                    <span className='placeholder'><FormattedMessage
                        id='badge.loading'
                        defaultMessage='Loading...'
                    /></span>
                </span>
            )}
            {!props.disableClick &&
                !repository.disabled &&
                repository.isPlatform &&
                props.navigateString &&
                repository.object &&
                !props.navigateOnDisplayName && (
                    <RiExternalLinkLine
                        onClick={(e) =>
                            !props.disableClick &&
                            !repository.disabled &&
                            repository.isPlatform &&
                            props.navigateString &&
                            repository.object &&
                            !props.navigateOnDisplayName &&
                            repository.adminOnClick(e, props.navigateString(repository.object))
                        }
                        fontSize={15}
                        className='hover:text-primary ms-1 cursor-pointer transition-all duration-300 ease-in-out hover:scale-110 hover:drop-shadow-lg'
                    />
                )}
        </span>
    );
};
